// extracted by mini-css-extract-plugin
export default {"legendContainer":"Legend_legendContainer__1PiKr","legendItem":"Legend_legendItem__oMXqk","legendButton":"Legend_legendButton__jpXfM"};